import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "doc-title" }
const _hoisted_3 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBoxComp = _resolveComponent("CheckBoxComp")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_ShadowBlock = _resolveComponent("ShadowBlock")!

  return (_openBlock(), _createBlock(_component_ShadowBlock, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (doc, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "doc",
          key: `cdoc_${doc.id}`,
          onClick: ($event: any) => (_ctx.toogle(idx))
        }, [
          _createVNode(_component_CheckBoxComp, {
            modelValue: doc.checked,
            "onUpdate:modelValue": ($event: any) => ((doc.checked) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createElementVNode("div", _hoisted_2, _toDisplayString(doc.name), 1)
        ], 8, _hoisted_1))
      }), 128)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PButton, {
          title: "Сохранить",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save')))
        }),
        _createVNode(_component_PButton, {
          title: "Отмена",
          type: "grey",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('resume')))
        })
      ])
    ]),
    _: 1
  }))
}